import { Link } from 'react-router-dom';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-900">
      {/* Header */}
      <header className="bg-gray-800 shadow-sm border-b border-gray-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-gray-400 hover:text-gray-200"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </Link>
            <h1 className="text-2xl font-bold text-white">
              Terms and Conditions
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-gray-800 rounded-2xl shadow-lg p-8 text-gray-300">
          <p className="text-sm text-gray-400 mb-8">Last Updated: December 14, 2025</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using the SSD Intranet ("Service"), you agree to be bound by these Terms and Conditions.
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">2. SMS Notifications Service</h2>
            <p className="mb-4">
              By opting in to receive SMS notifications from SSD Intranet, you consent to receive text messages
              related to important updates, alerts, and notifications from our organization.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Message frequency varies based on activity and updates</li>
              <li>Message and data rates may apply</li>
              <li>You can opt out at any time by visiting the SMS Notifications page or replying STOP to any message</li>
              <li>For help, reply HELP to any message or contact support</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">3. User Responsibilities</h2>
            <p className="mb-4">As a user of the SSD Intranet, you agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and current information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use the Service only for authorized business purposes</li>
              <li>Not share sensitive or confidential information outside the organization</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">4. Authorized Use</h2>
            <p className="mb-4">
              The SSD Intranet is intended for use by authorized employees and staff members of our organization only.
              Access is granted through Google Workspace authentication and is subject to organizational policies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">5. Intellectual Property</h2>
            <p className="mb-4">
              All content, features, and functionality of the SSD Intranet are owned by our organization and are
              protected by applicable intellectual property laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">6. Limitation of Liability</h2>
            <p className="mb-4">
              The Service is provided "as is" without warranties of any kind. We shall not be liable for any
              indirect, incidental, special, or consequential damages arising from your use of the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">7. Modifications</h2>
            <p className="mb-4">
              We reserve the right to modify these Terms and Conditions at any time. Continued use of the Service
              after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">8. Contact Information</h2>
            <p className="mb-4">
              For questions about these Terms and Conditions, please contact your system administrator or
              IT department.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-700">
            <p className="text-sm text-gray-400">
              See also: <Link to="/privacy" className="text-blue-400 hover:text-blue-300">Privacy Policy</Link>
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-gray-400 border-t border-gray-700">
        <p>&copy; {new Date().getFullYear()} SSD Intranet. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default TermsPage;
